import trim from "lodash/trim";
import {
  isKeywordOperator,
  isTypeString,
  isTypeKeyword,
  isTypeText
} from "views/components/searchbar/completions/token-helper";
const combiningOperators = [
  {
    name: "AND",
    value: "AND ",
    score: 10,
    meta: "operator"
  },
  {
    name: "OR",
    value: "OR ",
    score: 10,
    meta: "operator"
  }
];
const operators = [
  {
    name: "NOT",
    value: "NOT ",
    score: 10,
    meta: "operator"
  }
];
const _matchesFieldName = (prefix) => (field) => field.name.indexOf(prefix) >= 0;
const _lastNonEmptyToken = (tokens, currentTokenIdx) => tokens.slice(0, currentTokenIdx).reverse().find((token) => token.type !== "text" || trim(token.value) !== "");
class OperatorCompletion {
  constructor() {
    // eslint-disable-next-line class-methods-use-this
    this.getCompletions = ({
      currentToken,
      prevToken,
      prefix,
      tokens,
      currentTokenIdx
    }) => {
      if (isTypeKeyword(currentToken) || isTypeString(currentToken) || !(tokens == null ? void 0 : tokens.length) || !prefix || isKeywordOperator(prevToken) && prevToken.value === "NOT") {
        return [];
      }
      const lastNonEmptyToken = _lastNonEmptyToken(tokens, currentTokenIdx);
      if (!lastNonEmptyToken || lastNonEmptyToken && lastNonEmptyToken.type === "keyword.operator") {
        const matchesFieldName = _matchesFieldName(prefix);
        return operators.filter(matchesFieldName);
      }
      if (prevToken && (isTypeString(prevToken) || isTypeText(prevToken))) {
        const matchesFieldName = _matchesFieldName(prefix);
        return [...combiningOperators, ...operators].filter(matchesFieldName);
      }
      return [];
    };
  }
}
export default OperatorCompletion;
